import { render, staticRenderFns } from "./rowDetails.vue?vue&type=template&id=d84cee5c&"
import script from "./rowDetails.vue?vue&type=script&lang=js&"
export * from "./rowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports